import { useState, useRef, useEffect } from "react";
import { useIsMobile } from "../hooks/useIsMobile.js";
import { today } from "../utils/helpers.js";
import { Icon, BloomMark } from "./Icon.jsx";

// ─── NOTIF BELL ───────────────────────────────────────────────────────────────
export function NotifBell({ orders, live, onBlue = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const isMobile = useIsMobile();
  const todayStr = today();
  const todayOrders = (orders||[]).filter(o=>(o.date||o.order_date)===todayStr);

  // Close dropdown when clicking outside
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => { document.removeEventListener("mousedown", handler); document.removeEventListener("touchstart", handler); };
  }, [open]);

  const hasOrders = todayOrders.length > 0;

  return (
    <div ref={ref} style={{position:"relative"}}>
      <button onClick={()=>setOpen(o=>!o)}
        style={{
          background: onBlue ? (open ? "rgba(255,255,255,0.16)" : "transparent") : (open ? "var(--teal-light)" : "var(--white)"),
          border: onBlue ? "1.5px solid rgba(255,255,255,0.55)" : `1px solid ${open || hasOrders ? "var(--teal)" : "var(--border-mid)"}`,
          borderRadius: 4, width: 40, height: 40,
          display:"flex", alignItems:"center", justifyContent:"center",
          cursor:"pointer", position:"relative", color: onBlue ? "#fff" : "var(--ink)", transition:"background 0.2s, border-color 0.2s"
        }}>
        <Icon n="bell" size={18}/>
        {hasOrders && (
          <span style={{position:"absolute",top:-4,right:-4,background: onBlue ? "var(--butter)" : "var(--teal)",color: onBlue ? "#0B0B0B" : "var(--on-accent)",borderRadius:"50%",width:18,height:18,fontSize:10,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center"}}>
            {todayOrders.length}
          </span>
        )}
      </button>
      {/* Live indicator dot */}
      {live && <span style={{position:"absolute",bottom:1,right:1,width:8,height:8,borderRadius:"50%",background:"var(--green)",border:"2px solid var(--white)",animation:"liveDot 2s ease infinite"}}/>}
      {open && (
        <div className="card" style={{position:"absolute",right: isMobile ? -80 : 0,top:50,width:300,zIndex:300,overflow:"hidden",boxShadow:"0 12px 40px rgba(0,0,0,0.18)"}}>
          <div style={{padding:"14px 18px",borderBottom:"1px solid var(--border)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,fontSize:14}}>Today's Orders</span>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              {live && <span style={{fontSize:11,color:"var(--green)",fontWeight:700,display:"flex",alignItems:"center",gap:4}}><span style={{width:6,height:6,borderRadius:"50%",background:"var(--green)",display:"inline-block"}}/>Live</span>}
              <button onClick={()=>setOpen(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:16,color:"var(--ink-soft)",lineHeight:1,padding:"0 2px"}}>×</button>
            </div>
          </div>
          <div style={{maxHeight:300,overflowY:"auto"}}>
            {todayOrders.length===0
              ? <div style={{padding:"24px 18px",textAlign:"center",color:"var(--ink-soft)",fontSize:13}}>No orders today yet <BloomMark /></div>
              : todayOrders.map(o=>(
                <div key={o.id} style={{padding:"14px 18px",borderBottom:"1px solid var(--border)",display:"flex",gap:12,alignItems:"flex-start"}}>
                  <div style={{width:36,height:36,borderRadius:4,background:"var(--green-bg)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <Icon n="pkg" size={16} color="var(--green)"/>
                  </div>
                  <div>
                    <p style={{fontSize:13,fontWeight:600}}>Order from {o.customer_name||o.customerName||"Customer"}</p>
                    <p style={{fontSize:12,color:"var(--ink-soft)",marginTop:2}}>₹{(Number(o.amount)||0).toLocaleString()} · Auto-confirmed ✓</p>
                    <p style={{fontSize:11,color:"var(--ink-soft)",marginTop:1}}>{o.order_date||o.date}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
